/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiWorkflowRun, ApiWorkflowRunStep, ApiWorkflowStory } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of WorkflowRunsController.
 */
export class WorkflowRunsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /workflow_runs:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowRun>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiWorkflowRun>>>('/workflow_runs:query', query);
    }

    /**
     * Calls POST /workflow_runs:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowRun>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiWorkflowRun>>, ListRequest>('/workflow_runs:query', listRequest, query);
    }

    /**
     * Calls GET /workflow_runs/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiWorkflowRun>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiWorkflowRun>>(`/workflow_runs/${primaryId}`, query);
    }

    /**
     * Calls POST /workflow_runs:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowRun>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiWorkflowRun>>, ListRequestWithIds>('/workflow_runs:batch', listRequest, query);
    }

    /**
     * Calls GET /workflow_runs/{workflowRunId}/story
     */
    public getStory(workflowRunId: string): Promise<Result<ApiWorkflowStory>> {
        return this.http.get<Result<ApiWorkflowStory>>(`/workflow_runs/${workflowRunId}/story`);
    }

    /**
     * Calls POST /workflow_runs/{workflowRunId}/workflow_run_steps:query
     */
    public getSteps(workflowRunId: string, listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowRunStep>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiWorkflowRunStep>>, ListRequest>(`/workflow_runs/${workflowRunId}/workflow_run_steps:query`, listRequest, query);
    }
}
